// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Delivery runs (redesign) — /delivery-runs and its detail modal.
   Depends on dashboard-redesign.css for the shell tokens and the shared
   .rf-btn / .rf-segmented / .rf-num / .rf-spacer / .rf-empty. */

.dr-page {
  flex-grow: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* ---------------- toolbar ---------------- */
.dr-bar {
  background: #fff;
  border-bottom: 1px solid #e2dcd0;
  padding: 12px 28px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
}
.dr-cal-wrap {
  position: relative;
}
.dr-date-btn {
  height: 34px;
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 0 12px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  font: 600 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
}
.dr-date-btn:hover,
.dr-date-btn.is-open {
  border-color: #d8cfb8;
}
.dr-date-btn.is-set {
  border-color: #d8cfb8;
  background: #fbf8f0;
}
.dr-date-k {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #a29b8d;
}
.dr-caret {
  font-size: 10px;
  color: #a29b8d;
}
.dr-range-days {
  font-size: 11.5px;
  font-weight: 600;
  color: #8b8477;
}
.dr-cal {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 60;
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 12px;
  box-shadow: 0 14px 40px rgba(40, 34, 22, 0.16);
  padding: 14px;
}
.dr-presets {
  display: flex;
  gap: 2px;
  background: #eae6dd;
  padding: 3px;
  border-radius: 9px;
  margin-bottom: 12px;
}
.dr-presets button {
  flex: 1 1;
  border: none;
  cursor: pointer;
  padding: 6px 11px;
  border-radius: 7px;
  font: 600 12.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  background: transparent;
  color: #7c766a;
  white-space: nowrap;
}
.dr-presets button.is-active {
  background: #fff;
  color: #191714;
  box-shadow: 0 1px 3px rgba(40, 34, 22, 0.14);
}
.dr-cal-months {
  display: flex;
  gap: 18px;
}
.dr-cal-foot {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0ece3;
}
.dr-cal-hint {
  flex-grow: 1;
  text-align: right;
  font-size: 12px;
  color: #8b8477;
}
.dr-search {
  height: 34px;
  min-width: 220px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
}
.dr-search input {
  border: none;
  outline: none;
  background: none;
  width: 100%;
  font: 400 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
}
.dr-search-icon {
  width: 11px;
  height: 11px;
  border: 1.6px solid #a29b8d;
  border-radius: 50%;
  position: relative;
  flex-shrink: 0;
}
.dr-search-icon::after {
  content: "";
  position: absolute;
  right: -4px;
  bottom: -3px;
  width: 5px;
  height: 1.6px;
  background: #a29b8d;
  transform: rotate(45deg);
}

/* ---------------- KPI strip ---------------- */
.dr-kpis {
  padding: 16px 28px 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  flex-shrink: 0;
}
.dr-kpi {
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 12px;
  padding: 12px 15px;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.dr-kpi-k {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #a29b8d;
}
.dr-kpi-v {
  font-size: 24px;
  font-weight: 700;
  line-height: 1.1;
  color: #191714;
  font-variant-numeric: tabular-nums;
}
.dr-kpi-sub {
  font-size: 11.5px;
  color: #8b8477;
}

/* ---------------- products delivered by driver ---------------- */
.dr-drivers {
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 14px;
  padding: 14px 17px 16px;
  flex-shrink: 0;
}
.dr-drivers-head {
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}
.dr-drivers-title {
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 21px;
  line-height: 1.1;
  color: #191714;
}
.dr-drivers-range {
  font-size: 12px;
  color: #8b8477;
}
.dr-drivers-total {
  font-size: 12.5px;
  font-weight: 700;
  color: #191714;
}
.dr-drivers-empty {
  font-size: 13px;
  color: #8b8477;
  padding: 6px 0;
}
.dr-drivers-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 14px 26px;
}
.dr-driver {
  --dr-key: var(--rf-brand);
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
}
.dr-driver-face {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11.5px;
  font-weight: 700;
  color: var(--dr-key);
  border: 1.5px solid var(--dr-key);
}
.dr-driver-main {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.dr-driver-line {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.dr-driver-name {
  flex-grow: 1;
  min-width: 0;
  font-size: 13.5px;
  font-weight: 600;
  color: #191714;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dr-driver-n {
  font-size: 17px;
  font-weight: 700;
  color: #191714;
  font-variant-numeric: tabular-nums;
}
.dr-driver-track {
  height: 6px;
  border-radius: 3px;
  background: #f0ece3;
  overflow: hidden;
}
.dr-driver-fill {
  display: block;
  height: 100%;
  border-radius: 3px;
  background: var(--dr-key);
  transition: width 240ms ease;
}
.dr-driver-sub {
  font-size: 11.5px;
  color: #8b8477;
}

/* ---------------- list ---------------- */
.dr-body {
  flex-grow: 1;
  min-height: 0;
  padding: 16px 28px 28px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.dr-daygroup {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.dr-dayhead {
  display: flex;
  align-items: center;
  gap: 10px;
}
.dr-dayhead-label {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--rf-brand);
  white-space: nowrap;
}
.dr-dayhead-rule {
  flex-grow: 1;
  height: 1px;
  background: var(--rf-brand-line);
}
.dr-dayhead-count {
  font-size: 11.5px;
  color: #a29b8d;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.dr-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 12px;
}

/* ---- run card: a dispatch docket ----
   Built around what a run sheet actually carries in this shop — a zone,
   a driver, and how much is on the truck. Fields that are usually empty
   (plate, comment) appear only when they are filled, instead of printing
   a row of dashes. The driver's colour is carried by the avatar ring and
   the route line rather than a generic coloured edge. */
.dr-card {
  --dr-key: var(--rf-brand);
  position: relative;
  text-align: left;
  font: inherit;
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 14px;
  padding: 14px 17px 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: box-shadow 160ms, border-color 160ms, transform 160ms;
}
.dr-card:hover {
  border-color: #d8cfb8;
  box-shadow: 0 10px 26px rgba(40, 34, 22, 0.11);
  transform: translateY(-2px);
}
.dr-card.is-active {
  border-color: var(--dr-key);
  box-shadow: 0 0 0 2px rgba(var(--rf-brand-lite-rgb), 0.2);
}

/* zone label + run number */
.dr-top {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
}
.dr-zone {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex-grow: 1;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.13em;
  text-transform: uppercase;
  color: var(--dr-key);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dr-zone::before {
  content: "";
  width: 16px;
  height: 2px;
  border-radius: 1px;
  background: var(--dr-key);
  flex-shrink: 0;
}
.dr-zone.is-empty {
  color: #c4bdad;
}
.dr-zone.is-empty::before {
  background: #ddd7cb;
}
.dr-runno {
  flex-shrink: 0;
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 19px;
  line-height: 1;
  color: #cdc5b4;
  font-variant-numeric: tabular-nums;
}

/* driver */
.dr-who {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-top: 11px;
  min-width: 0;
}
.dr-face {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: var(--dr-key);
  background: #fff;
  border: 1.5px solid var(--dr-key);
  box-shadow: inset 0 0 0 3px #fff, 0 0 0 0 transparent;
}
.dr-who-text {
  min-width: 0;
}
.dr-name {
  display: block;
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 23px;
  line-height: 1.12;
  color: #191714;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dr-plate {
  display: inline-block;
  margin-top: 3px;
  padding: 1px 6px;
  border-radius: 4px;
  border: 1px solid #e2dcd0;
  background: #faf8f4;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: #7c766a;
  font-variant-numeric: tabular-nums;
}

/* the note, only when the run carries one */
.dr-note {
  margin-top: 11px;
  padding-left: 10px;
  border-left: 2px solid var(--rf-brand-edge);
  font-size: 12px;
  line-height: 1.45;
  color: #6f6a60;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* load */
.dr-load {
  display: flex;
  align-items: flex-end;
  gap: 18px;
  margin-top: 13px;
  padding-top: 11px;
  border-top: 1px solid #f0ece3;
}
.dr-stat {
  display: flex;
  align-items: baseline;
  gap: 5px;
}
.dr-stat-n {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
  color: #191714;
  font-variant-numeric: tabular-nums;
}
.dr-stat-k {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #a29b8d;
}

/* route line — one mark per stop between the depot bar and the return
   pin, so a long run literally draws a longer route */
.dr-route {
  position: relative;
  height: 24px;
  margin: 10px -17px 0;
  padding: 0 17px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.dr-route::before {
  content: "";
  position: absolute;
  left: 17px;
  right: 17px;
  height: 1px;
  background: repeating-linear-gradient(
    to right,
    #e2dcd0 0 3px,
    transparent 3px 7px
  );
}
.dr-route-start {
  position: relative;
  width: 3px;
  height: 11px;
  border-radius: 2px;
  background: var(--dr-key);
  flex-shrink: 0;
}
.dr-stop-dot {
  position: relative;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--dr-key);
  opacity: 0.6;
  flex-shrink: 0;
}
.dr-card:hover .dr-stop-dot {
  opacity: 0.9;
}
.dr-route-more {
  position: relative;
  font-size: 10px;
  font-weight: 700;
  color: var(--dr-key);
  opacity: 0.8;
  font-variant-numeric: tabular-nums;
}
.dr-route-end {
  position: relative;
  margin-left: auto;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  border: 1.5px solid var(--dr-key);
  background: #fff;
  flex-shrink: 0;
}

/* ---------------- pagination ---------------- */
.dr-pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding-top: 4px;
}
.dr-pager button {
  min-width: 32px;
  height: 32px;
  padding: 0 9px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
  color: #4a453c;
  font: 600 12.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  cursor: pointer;
  font-variant-numeric: tabular-nums;
}
.dr-pager button:hover:not(:disabled) {
  background: #f6f4ef;
}
.dr-pager button.is-active {
  background: var(--rf-brand);
  border-color: var(--rf-brand);
  color: #fff;
}
.dr-pager button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ================= detail modal ================= */
.rd-wrap {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px;
}
.rd-scrim {
  position: absolute;
  inset: 0;
  background: rgba(25, 23, 20, 0.34);
}
.rd-modal {
  position: relative;
  width: 1220px;
  max-width: 100%;
  max-height: 100%;
  background: #fff;
  border: 1px solid #ddd7cb;
  border-radius: 14px;
  box-shadow: 0 30px 80px rgba(40, 34, 22, 0.3);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.rd-head {
  padding: 16px 24px;
  border-bottom: 1px solid #e2dcd0;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  background: #fdfcfa;
  /* style.css styles bare header tags for legacy pages — reset */
  text-align: left;
  font-weight: 400;
  margin: 0;
}
.rd-badge {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: var(--rf-brand);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 21px;
  flex-shrink: 0;
}
.rd-head-main {
  min-width: 0;
  flex-grow: 1;
}
.rd-eyebrow {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #a29b8d;
}
.rd-title {
  /* same serif the run cards name the driver in, so opening a card keeps
     its identity */
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 25px;
  font-weight: 400;
  color: #191714;
  line-height: 1.12;
  margin: 1px 0 0;
}
.rd-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.rd-icon-btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid #e2dcd0;
  background: #fff;
  color: #6f6a60;
  font-size: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.rd-icon-btn:hover {
  background: #f6f4ef;
  color: #191714;
}
.rd-icon-btn.is-danger:hover {
  background: #f7ebe9;
  border-color: #e3b9b4;
  color: #a8483e;
}

.rd-meta {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  background: #fff;
  border-bottom: 1px solid #e2dcd0;
  flex-shrink: 0;
}
.rd-meta-cell {
  padding: 11px 24px;
  min-width: 0;
  border-left: 1px solid #e7e3da;
}
.rd-meta-cell:nth-child(5n + 1) {
  border-left: none;
}
.rd-meta-k {
  display: block;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #bdb6a7;
}
.rd-meta-v {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #191714;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.rd-meta-v.is-empty {
  color: #c4bdad;
  font-weight: 400;
}

.rd-body {
  flex-grow: 1;
  overflow-y: auto;
  padding: 18px 24px 24px;
}
.rd-sec-title {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #a29b8d;
  margin-bottom: 9px;
  display: flex;
  align-items: center;
  gap: 9px;
}
.rd-sec-title span {
  color: #c4bdad;
  font-weight: 500;
  letter-spacing: 0;
  text-transform: none;
  font-size: 11.5px;
}

/* stops ----------------------------------------------------------
   Column widths follow what the fields actually hold: destinations are
   full postal addresses and times are phrases ("7.00 - 7.30 AM
   DELIVERY"), not a clock value — the old fixed 84px nowrap time column
   overflowed under the product chips. Every cell starts on the same
   first line: the row is top-aligned and each cell shares the same
   leading, with the stop number and the chips nudged onto that line. */
.rd-stops {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.rd-stop {
  display: grid;
  grid-template-columns:
    28px
    minmax(0, 1fr)
    minmax(0, 1.5fr)
    minmax(118px, 0.7fr)
    minmax(0, 1.25fr);
  gap: 18px;
  align-items: start;
  padding: 13px 16px;
  border: 1px solid #e7e3da;
  border-radius: 10px;
  background: #fff;
}
.rd-stop > * {
  /* the shared text line every column's first row sits on */
  line-height: 1.5;
  min-width: 0;
}
.rd-stop.is-head {
  border: none;
  background: none;
  padding: 0 16px 2px;
}
.rd-stop.is-head > span {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #bdb6a7;
  line-height: 1.5;
}
.rd-stop-num {
  width: 24px;
  height: 24px;
  margin-top: -1px;
  border-radius: 50%;
  background: #f4f1ea;
  color: #6f6a60;
  font-size: 11.5px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}
.rd-stop.is-funeral .rd-stop-num {
  background: var(--rf-brand-tint);
  color: var(--rf-brand);
}
.rd-stop.is-retail .rd-stop-num {
  background: #e9f1f0;
  color: #2f5b57;
}
.rd-stop-name {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #191714;
  /* the same leading every other cell uses, so the name's first line
     lands on the row's shared baseline instead of 1px above it */
  line-height: 1.5;
  overflow-wrap: anywhere;
}
.rd-stop-type {
  display: block;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #bdb6a7;
  line-height: 1.5;
  margin-top: 2px;
}
.rd-stop-dest {
  font-size: 12.5px;
  color: #4a453c;
  overflow-wrap: anywhere;
}
/* the funeral director (or "DIRECT") owns its own line above the
   address — inline it wrapped the address around itself */
.rd-fd {
  display: inline-block;
  margin-bottom: 3px;
  padding: 1px 7px;
  border-radius: 4px;
  background: var(--rf-brand-tint);
  border: 1px solid var(--rf-brand-edge);
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 1.5;
  color: var(--rf-brand-deep);
}
.rd-stop-addr {
  display: block;
}
.rd-stop-service {
  display: block;
  font-size: 11.5px;
  font-weight: 600;
  color: #8b5a1e;
}
.rd-stop-time {
  font-size: 12.5px;
  font-weight: 600;
  color: #191714;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}
.rd-stop-time.is-empty {
  color: #c4bdad;
  font-weight: 400;
}
.rd-prods {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  /* the chip's border + padding push its label down; pull the row back
     up so the label sits on the shared text line */
  margin-top: -2px;
}
.rd-prod {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  background: #f4f1ea;
  border: 1px solid #e7e3da;
  font-size: 11px;
  line-height: 1.45;
  color: #4a453c;
  white-space: nowrap;
}
.rd-prod.is-addon {
  background: #eaf1e9;
  border-color: #d6e4d4;
  color: #3c6341;
}

/* description / comment */
.rd-notes {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 22px;
}
.rd-note {
  border: 1px solid #e7e3da;
  border-radius: 10px;
  overflow: hidden;
}
.rd-note-k {
  padding: 7px 12px;
  background: #f6f4ef;
  border-bottom: 1px solid #e7e3da;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #8b8477;
}
.rd-note-v {
  padding: 11px 12px;
  font-size: 12.5px;
  color: #4a453c;
  line-height: 1.5;
  min-height: 56px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.rd-note-v.is-empty {
  color: #c4bdad;
}

/* delete confirmation */
.rd-confirm {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 24px;
  background: #f7ebe9;
  border-bottom: 1px solid #e3b9b4;
  font-size: 12.5px;
  color: #7d332b;
  flex-shrink: 0;
}
.rd-confirm b {
  font-weight: 700;
}
.rd-btn-danger {
  border: none;
  background: #a8483e;
  color: #fff;
  padding: 0 14px;
}
.rd-btn-danger:hover:not(:disabled) {
  background: #8f3c33;
}
.rd-btn-danger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 1274px) {
  .rd-meta {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .rd-meta-cell {
    border-left: 1px solid #e7e3da;
  }
  .rd-meta-cell:nth-child(3n + 1) {
    border-left: none;
  }
  .rd-meta-cell:nth-child(n + 4) {
    border-top: 1px solid #e7e3da;
  }
  .rd-stop {
    grid-template-columns:
      28px
      minmax(0, 1fr)
      minmax(0, 1.35fr)
      minmax(0, 1.15fr);
    gap: 14px;
  }
  /* time folds under the destination when the row can't hold five */
  .rd-stop-time {
    grid-column: 3;
    margin-top: 4px;
  }
  .rd-stop.is-head > span:nth-child(4) {
    display: none;
  }
}
@media (max-width: 1100px) {
  .dr-kpis {
    grid-template-columns: repeat(2, 1fr);
  }
  .rd-meta {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .rd-meta-cell:nth-child(2n + 1) {
    border-left: none;
  }
  .rd-meta-cell:nth-child(3n + 1) {
    border-left: 1px solid #e7e3da;
  }
  .rd-meta-cell:nth-child(2n + 1) {
    border-left: none;
  }
  .rd-meta-cell:nth-child(n + 3) {
    border-top: 1px solid #e7e3da;
  }
  .rd-stop {
    grid-template-columns: 28px minmax(0, 1fr);
    row-gap: 6px;
  }
  .rd-stop-time {
    grid-column: 2;
    margin-top: 0;
  }
  .rd-stop.is-head {
    display: none;
  }
  .rd-stop > *:not(.rd-stop-num) {
    grid-column: 2;
  }
  .rd-notes {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 860px) {
  .dr-cal {
    position: fixed;
    top: 120px;
    left: 16px;
    right: 16px;
    max-height: calc(100vh - 140px);
    overflow-y: auto;
  }
  .dr-cal-months {
    flex-direction: column;
  }
  .dr-cal-foot {
    flex-wrap: wrap;
  }
  .dr-bar,
  .dr-kpis,
  .dr-body {
    padding-left: 16px;
    padding-right: 16px;
  }
  .rd-wrap {
    padding: 0;
  }
  .rd-modal {
    border-radius: 0;
    height: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/delivery-runs.css"],"names":[],"mappings":"AAAA;;gEAEgE;;AAEhE;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,8DAA8D;EAC9D,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;AACf;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gEAAgE;EAChE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,8DAA8D;EAC9D,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,gDAAgD;AAChD;EACE,oBAAoB;EACpB,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,mEAAmE;AACnE;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,iCAAiC;AACnC;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;;;;;wDAKwD;AACxD;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iEAAiE;AACnE;AACA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,cAAc;EACd,cAAc;EACd,kCAAkC;AACpC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iCAAiC;EACjC,qDAAqD;AACvD;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,kCAAkC;AACpC;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;sDACsD;AACtD;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX;;;;GAIC;AACH;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gEAAgE;EAChE,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,qDAAqD;AACrD;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,+DAA+D;EAC/D,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE;mBACiB;EACjB,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;;;;;uEAMuE;AACvE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb;;;;;qBAKmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,0DAA0D;EAC1D,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd;iEAC+D;EAC/D,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;AACA;0DAC0D;AAC1D;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR;mDACiD;EACjD,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE;;;;uBAImB;IACnB,SAAS;EACX;EACA,kEAAkE;EAClE;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,gDAAgD;EAClD;EACA;IACE,iBAAiB;EACnB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,0CAA0C;IAC1C,YAAY;EACd;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,eAAe;IACf,UAAU;IACV,UAAU;IACV,WAAW;IACX,+BAA+B;IAC/B,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;AACF","sourcesContent":["/* Delivery runs (redesign) — /delivery-runs and its detail modal.\n   Depends on dashboard-redesign.css for the shell tokens and the shared\n   .rf-btn / .rf-segmented / .rf-num / .rf-spacer / .rf-empty. */\n\n.dr-page {\n  flex-grow: 1;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ---------------- toolbar ---------------- */\n.dr-bar {\n  background: #fff;\n  border-bottom: 1px solid #e2dcd0;\n  padding: 12px 28px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n.dr-cal-wrap {\n  position: relative;\n}\n.dr-date-btn {\n  height: 34px;\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 0 12px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n  cursor: pointer;\n  font: 600 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n}\n.dr-date-btn:hover,\n.dr-date-btn.is-open {\n  border-color: #d8cfb8;\n}\n.dr-date-btn.is-set {\n  border-color: #d8cfb8;\n  background: #fbf8f0;\n}\n.dr-date-k {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #a29b8d;\n}\n.dr-caret {\n  font-size: 10px;\n  color: #a29b8d;\n}\n.dr-range-days {\n  font-size: 11.5px;\n  font-weight: 600;\n  color: #8b8477;\n}\n.dr-cal {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  z-index: 60;\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 12px;\n  box-shadow: 0 14px 40px rgba(40, 34, 22, 0.16);\n  padding: 14px;\n}\n.dr-presets {\n  display: flex;\n  gap: 2px;\n  background: #eae6dd;\n  padding: 3px;\n  border-radius: 9px;\n  margin-bottom: 12px;\n}\n.dr-presets button {\n  flex: 1;\n  border: none;\n  cursor: pointer;\n  padding: 6px 11px;\n  border-radius: 7px;\n  font: 600 12.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  background: transparent;\n  color: #7c766a;\n  white-space: nowrap;\n}\n.dr-presets button.is-active {\n  background: #fff;\n  color: #191714;\n  box-shadow: 0 1px 3px rgba(40, 34, 22, 0.14);\n}\n.dr-cal-months {\n  display: flex;\n  gap: 18px;\n}\n.dr-cal-foot {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #f0ece3;\n}\n.dr-cal-hint {\n  flex-grow: 1;\n  text-align: right;\n  font-size: 12px;\n  color: #8b8477;\n}\n.dr-search {\n  height: 34px;\n  min-width: 220px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 12px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n}\n.dr-search input {\n  border: none;\n  outline: none;\n  background: none;\n  width: 100%;\n  font: 400 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n}\n.dr-search-icon {\n  width: 11px;\n  height: 11px;\n  border: 1.6px solid #a29b8d;\n  border-radius: 50%;\n  position: relative;\n  flex-shrink: 0;\n}\n.dr-search-icon::after {\n  content: \"\";\n  position: absolute;\n  right: -4px;\n  bottom: -3px;\n  width: 5px;\n  height: 1.6px;\n  background: #a29b8d;\n  transform: rotate(45deg);\n}\n\n/* ---------------- KPI strip ---------------- */\n.dr-kpis {\n  padding: 16px 28px 0;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n  flex-shrink: 0;\n}\n.dr-kpi {\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 12px;\n  padding: 12px 15px;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n.dr-kpi-k {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #a29b8d;\n}\n.dr-kpi-v {\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.1;\n  color: #191714;\n  font-variant-numeric: tabular-nums;\n}\n.dr-kpi-sub {\n  font-size: 11.5px;\n  color: #8b8477;\n}\n\n/* ---------------- products delivered by driver ---------------- */\n.dr-drivers {\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 14px;\n  padding: 14px 17px 16px;\n  flex-shrink: 0;\n}\n.dr-drivers-head {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 14px;\n}\n.dr-drivers-title {\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 21px;\n  line-height: 1.1;\n  color: #191714;\n}\n.dr-drivers-range {\n  font-size: 12px;\n  color: #8b8477;\n}\n.dr-drivers-total {\n  font-size: 12.5px;\n  font-weight: 700;\n  color: #191714;\n}\n.dr-drivers-empty {\n  font-size: 13px;\n  color: #8b8477;\n  padding: 6px 0;\n}\n.dr-drivers-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 14px 26px;\n}\n.dr-driver {\n  --dr-key: var(--rf-brand);\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  min-width: 0;\n}\n.dr-driver-face {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11.5px;\n  font-weight: 700;\n  color: var(--dr-key);\n  border: 1.5px solid var(--dr-key);\n}\n.dr-driver-main {\n  flex-grow: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.dr-driver-line {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n.dr-driver-name {\n  flex-grow: 1;\n  min-width: 0;\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #191714;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.dr-driver-n {\n  font-size: 17px;\n  font-weight: 700;\n  color: #191714;\n  font-variant-numeric: tabular-nums;\n}\n.dr-driver-track {\n  height: 6px;\n  border-radius: 3px;\n  background: #f0ece3;\n  overflow: hidden;\n}\n.dr-driver-fill {\n  display: block;\n  height: 100%;\n  border-radius: 3px;\n  background: var(--dr-key);\n  transition: width 240ms ease;\n}\n.dr-driver-sub {\n  font-size: 11.5px;\n  color: #8b8477;\n}\n\n/* ---------------- list ---------------- */\n.dr-body {\n  flex-grow: 1;\n  min-height: 0;\n  padding: 16px 28px 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n.dr-daygroup {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.dr-dayhead {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.dr-dayhead-label {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--rf-brand);\n  white-space: nowrap;\n}\n.dr-dayhead-rule {\n  flex-grow: 1;\n  height: 1px;\n  background: var(--rf-brand-line);\n}\n.dr-dayhead-count {\n  font-size: 11.5px;\n  color: #a29b8d;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.dr-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 12px;\n}\n\n/* ---- run card: a dispatch docket ----\n   Built around what a run sheet actually carries in this shop — a zone,\n   a driver, and how much is on the truck. Fields that are usually empty\n   (plate, comment) appear only when they are filled, instead of printing\n   a row of dashes. The driver's colour is carried by the avatar ring and\n   the route line rather than a generic coloured edge. */\n.dr-card {\n  --dr-key: var(--rf-brand);\n  position: relative;\n  text-align: left;\n  font: inherit;\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 14px;\n  padding: 14px 17px 0;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  transition: box-shadow 160ms, border-color 160ms, transform 160ms;\n}\n.dr-card:hover {\n  border-color: #d8cfb8;\n  box-shadow: 0 10px 26px rgba(40, 34, 22, 0.11);\n  transform: translateY(-2px);\n}\n.dr-card.is-active {\n  border-color: var(--dr-key);\n  box-shadow: 0 0 0 2px rgba(var(--rf-brand-lite-rgb), 0.2);\n}\n\n/* zone label + run number */\n.dr-top {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  position: relative;\n}\n.dr-zone {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  flex-grow: 1;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.13em;\n  text-transform: uppercase;\n  color: var(--dr-key);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.dr-zone::before {\n  content: \"\";\n  width: 16px;\n  height: 2px;\n  border-radius: 1px;\n  background: var(--dr-key);\n  flex-shrink: 0;\n}\n.dr-zone.is-empty {\n  color: #c4bdad;\n}\n.dr-zone.is-empty::before {\n  background: #ddd7cb;\n}\n.dr-runno {\n  flex-shrink: 0;\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 19px;\n  line-height: 1;\n  color: #cdc5b4;\n  font-variant-numeric: tabular-nums;\n}\n\n/* driver */\n.dr-who {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  margin-top: 11px;\n  min-width: 0;\n}\n.dr-face {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  color: var(--dr-key);\n  background: #fff;\n  border: 1.5px solid var(--dr-key);\n  box-shadow: inset 0 0 0 3px #fff, 0 0 0 0 transparent;\n}\n.dr-who-text {\n  min-width: 0;\n}\n.dr-name {\n  display: block;\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 23px;\n  line-height: 1.12;\n  color: #191714;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.dr-plate {\n  display: inline-block;\n  margin-top: 3px;\n  padding: 1px 6px;\n  border-radius: 4px;\n  border: 1px solid #e2dcd0;\n  background: #faf8f4;\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  color: #7c766a;\n  font-variant-numeric: tabular-nums;\n}\n\n/* the note, only when the run carries one */\n.dr-note {\n  margin-top: 11px;\n  padding-left: 10px;\n  border-left: 2px solid var(--rf-brand-edge);\n  font-size: 12px;\n  line-height: 1.45;\n  color: #6f6a60;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* load */\n.dr-load {\n  display: flex;\n  align-items: flex-end;\n  gap: 18px;\n  margin-top: 13px;\n  padding-top: 11px;\n  border-top: 1px solid #f0ece3;\n}\n.dr-stat {\n  display: flex;\n  align-items: baseline;\n  gap: 5px;\n}\n.dr-stat-n {\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 1;\n  color: #191714;\n  font-variant-numeric: tabular-nums;\n}\n.dr-stat-k {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #a29b8d;\n}\n\n/* route line — one mark per stop between the depot bar and the return\n   pin, so a long run literally draws a longer route */\n.dr-route {\n  position: relative;\n  height: 24px;\n  margin: 10px -17px 0;\n  padding: 0 17px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.dr-route::before {\n  content: \"\";\n  position: absolute;\n  left: 17px;\n  right: 17px;\n  height: 1px;\n  background: repeating-linear-gradient(\n    to right,\n    #e2dcd0 0 3px,\n    transparent 3px 7px\n  );\n}\n.dr-route-start {\n  position: relative;\n  width: 3px;\n  height: 11px;\n  border-radius: 2px;\n  background: var(--dr-key);\n  flex-shrink: 0;\n}\n.dr-stop-dot {\n  position: relative;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--dr-key);\n  opacity: 0.6;\n  flex-shrink: 0;\n}\n.dr-card:hover .dr-stop-dot {\n  opacity: 0.9;\n}\n.dr-route-more {\n  position: relative;\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--dr-key);\n  opacity: 0.8;\n  font-variant-numeric: tabular-nums;\n}\n.dr-route-end {\n  position: relative;\n  margin-left: auto;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  border: 1.5px solid var(--dr-key);\n  background: #fff;\n  flex-shrink: 0;\n}\n\n/* ---------------- pagination ---------------- */\n.dr-pager {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding-top: 4px;\n}\n.dr-pager button {\n  min-width: 32px;\n  height: 32px;\n  padding: 0 9px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n  color: #4a453c;\n  font: 600 12.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  cursor: pointer;\n  font-variant-numeric: tabular-nums;\n}\n.dr-pager button:hover:not(:disabled) {\n  background: #f6f4ef;\n}\n.dr-pager button.is-active {\n  background: var(--rf-brand);\n  border-color: var(--rf-brand);\n  color: #fff;\n}\n.dr-pager button:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ================= detail modal ================= */\n.rd-wrap {\n  position: fixed;\n  inset: 0;\n  z-index: 80;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 28px;\n}\n.rd-scrim {\n  position: absolute;\n  inset: 0;\n  background: rgba(25, 23, 20, 0.34);\n}\n.rd-modal {\n  position: relative;\n  width: 1220px;\n  max-width: 100%;\n  max-height: 100%;\n  background: #fff;\n  border: 1px solid #ddd7cb;\n  border-radius: 14px;\n  box-shadow: 0 30px 80px rgba(40, 34, 22, 0.3);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.rd-head {\n  padding: 16px 24px;\n  border-bottom: 1px solid #e2dcd0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n  background: #fdfcfa;\n  /* style.css styles bare header tags for legacy pages — reset */\n  text-align: left;\n  font-weight: 400;\n  margin: 0;\n}\n.rd-badge {\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  background: var(--rf-brand);\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 21px;\n  flex-shrink: 0;\n}\n.rd-head-main {\n  min-width: 0;\n  flex-grow: 1;\n}\n.rd-eyebrow {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #a29b8d;\n}\n.rd-title {\n  /* same serif the run cards name the driver in, so opening a card keeps\n     its identity */\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 25px;\n  font-weight: 400;\n  color: #191714;\n  line-height: 1.12;\n  margin: 1px 0 0;\n}\n.rd-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n.rd-icon-btn {\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  border: 1px solid #e2dcd0;\n  background: #fff;\n  color: #6f6a60;\n  font-size: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n.rd-icon-btn:hover {\n  background: #f6f4ef;\n  color: #191714;\n}\n.rd-icon-btn.is-danger:hover {\n  background: #f7ebe9;\n  border-color: #e3b9b4;\n  color: #a8483e;\n}\n\n.rd-meta {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  background: #fff;\n  border-bottom: 1px solid #e2dcd0;\n  flex-shrink: 0;\n}\n.rd-meta-cell {\n  padding: 11px 24px;\n  min-width: 0;\n  border-left: 1px solid #e7e3da;\n}\n.rd-meta-cell:nth-child(5n + 1) {\n  border-left: none;\n}\n.rd-meta-k {\n  display: block;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #bdb6a7;\n}\n.rd-meta-v {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #191714;\n  margin-top: 2px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n.rd-meta-v.is-empty {\n  color: #c4bdad;\n  font-weight: 400;\n}\n\n.rd-body {\n  flex-grow: 1;\n  overflow-y: auto;\n  padding: 18px 24px 24px;\n}\n.rd-sec-title {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #a29b8d;\n  margin-bottom: 9px;\n  display: flex;\n  align-items: center;\n  gap: 9px;\n}\n.rd-sec-title span {\n  color: #c4bdad;\n  font-weight: 500;\n  letter-spacing: 0;\n  text-transform: none;\n  font-size: 11.5px;\n}\n\n/* stops ----------------------------------------------------------\n   Column widths follow what the fields actually hold: destinations are\n   full postal addresses and times are phrases (\"7.00 - 7.30 AM\n   DELIVERY\"), not a clock value — the old fixed 84px nowrap time column\n   overflowed under the product chips. Every cell starts on the same\n   first line: the row is top-aligned and each cell shares the same\n   leading, with the stop number and the chips nudged onto that line. */\n.rd-stops {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.rd-stop {\n  display: grid;\n  grid-template-columns:\n    28px\n    minmax(0, 1fr)\n    minmax(0, 1.5fr)\n    minmax(118px, 0.7fr)\n    minmax(0, 1.25fr);\n  gap: 18px;\n  align-items: start;\n  padding: 13px 16px;\n  border: 1px solid #e7e3da;\n  border-radius: 10px;\n  background: #fff;\n}\n.rd-stop > * {\n  /* the shared text line every column's first row sits on */\n  line-height: 1.5;\n  min-width: 0;\n}\n.rd-stop.is-head {\n  border: none;\n  background: none;\n  padding: 0 16px 2px;\n}\n.rd-stop.is-head > span {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #bdb6a7;\n  line-height: 1.5;\n}\n.rd-stop-num {\n  width: 24px;\n  height: 24px;\n  margin-top: -1px;\n  border-radius: 50%;\n  background: #f4f1ea;\n  color: #6f6a60;\n  font-size: 11.5px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-variant-numeric: tabular-nums;\n  line-height: 1;\n}\n.rd-stop.is-funeral .rd-stop-num {\n  background: var(--rf-brand-tint);\n  color: var(--rf-brand);\n}\n.rd-stop.is-retail .rd-stop-num {\n  background: #e9f1f0;\n  color: #2f5b57;\n}\n.rd-stop-name {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #191714;\n  /* the same leading every other cell uses, so the name's first line\n     lands on the row's shared baseline instead of 1px above it */\n  line-height: 1.5;\n  overflow-wrap: anywhere;\n}\n.rd-stop-type {\n  display: block;\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #bdb6a7;\n  line-height: 1.5;\n  margin-top: 2px;\n}\n.rd-stop-dest {\n  font-size: 12.5px;\n  color: #4a453c;\n  overflow-wrap: anywhere;\n}\n/* the funeral director (or \"DIRECT\") owns its own line above the\n   address — inline it wrapped the address around itself */\n.rd-fd {\n  display: inline-block;\n  margin-bottom: 3px;\n  padding: 1px 7px;\n  border-radius: 4px;\n  background: var(--rf-brand-tint);\n  border: 1px solid var(--rf-brand-edge);\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  line-height: 1.5;\n  color: var(--rf-brand-deep);\n}\n.rd-stop-addr {\n  display: block;\n}\n.rd-stop-service {\n  display: block;\n  font-size: 11.5px;\n  font-weight: 600;\n  color: #8b5a1e;\n}\n.rd-stop-time {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #191714;\n  font-variant-numeric: tabular-nums;\n  overflow-wrap: anywhere;\n}\n.rd-stop-time.is-empty {\n  color: #c4bdad;\n  font-weight: 400;\n}\n.rd-prods {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  /* the chip's border + padding push its label down; pull the row back\n     up so the label sits on the shared text line */\n  margin-top: -2px;\n}\n.rd-prod {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #f4f1ea;\n  border: 1px solid #e7e3da;\n  font-size: 11px;\n  line-height: 1.45;\n  color: #4a453c;\n  white-space: nowrap;\n}\n.rd-prod.is-addon {\n  background: #eaf1e9;\n  border-color: #d6e4d4;\n  color: #3c6341;\n}\n\n/* description / comment */\n.rd-notes {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin-top: 22px;\n}\n.rd-note {\n  border: 1px solid #e7e3da;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.rd-note-k {\n  padding: 7px 12px;\n  background: #f6f4ef;\n  border-bottom: 1px solid #e7e3da;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #8b8477;\n}\n.rd-note-v {\n  padding: 11px 12px;\n  font-size: 12.5px;\n  color: #4a453c;\n  line-height: 1.5;\n  min-height: 56px;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n.rd-note-v.is-empty {\n  color: #c4bdad;\n}\n\n/* delete confirmation */\n.rd-confirm {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 11px 24px;\n  background: #f7ebe9;\n  border-bottom: 1px solid #e3b9b4;\n  font-size: 12.5px;\n  color: #7d332b;\n  flex-shrink: 0;\n}\n.rd-confirm b {\n  font-weight: 700;\n}\n.rd-btn-danger {\n  border: none;\n  background: #a8483e;\n  color: #fff;\n  padding: 0 14px;\n}\n.rd-btn-danger:hover:not(:disabled) {\n  background: #8f3c33;\n}\n.rd-btn-danger:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n@media (max-width: 1274px) {\n  .rd-meta {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n  .rd-meta-cell {\n    border-left: 1px solid #e7e3da;\n  }\n  .rd-meta-cell:nth-child(3n + 1) {\n    border-left: none;\n  }\n  .rd-meta-cell:nth-child(n + 4) {\n    border-top: 1px solid #e7e3da;\n  }\n  .rd-stop {\n    grid-template-columns:\n      28px\n      minmax(0, 1fr)\n      minmax(0, 1.35fr)\n      minmax(0, 1.15fr);\n    gap: 14px;\n  }\n  /* time folds under the destination when the row can't hold five */\n  .rd-stop-time {\n    grid-column: 3;\n    margin-top: 4px;\n  }\n  .rd-stop.is-head > span:nth-child(4) {\n    display: none;\n  }\n}\n@media (max-width: 1100px) {\n  .dr-kpis {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .rd-meta {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .rd-meta-cell:nth-child(2n + 1) {\n    border-left: none;\n  }\n  .rd-meta-cell:nth-child(3n + 1) {\n    border-left: 1px solid #e7e3da;\n  }\n  .rd-meta-cell:nth-child(2n + 1) {\n    border-left: none;\n  }\n  .rd-meta-cell:nth-child(n + 3) {\n    border-top: 1px solid #e7e3da;\n  }\n  .rd-stop {\n    grid-template-columns: 28px minmax(0, 1fr);\n    row-gap: 6px;\n  }\n  .rd-stop-time {\n    grid-column: 2;\n    margin-top: 0;\n  }\n  .rd-stop.is-head {\n    display: none;\n  }\n  .rd-stop > *:not(.rd-stop-num) {\n    grid-column: 2;\n  }\n  .rd-notes {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n@media (max-width: 860px) {\n  .dr-cal {\n    position: fixed;\n    top: 120px;\n    left: 16px;\n    right: 16px;\n    max-height: calc(100vh - 140px);\n    overflow-y: auto;\n  }\n  .dr-cal-months {\n    flex-direction: column;\n  }\n  .dr-cal-foot {\n    flex-wrap: wrap;\n  }\n  .dr-bar,\n  .dr-kpis,\n  .dr-body {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n  .rd-wrap {\n    padding: 0;\n  }\n  .rd-modal {\n    border-radius: 0;\n    height: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
